import React from 'react';
import { styled } from '@mui/material';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { getObjectValue, getStringValue } from 'utilities';
import { DCFSummaryTableProps } from './types';

const PREFIX = 'DCFSummaryTable';

const classes = {
  spreadsheet: `${PREFIX}-spreadsheet`,
};

const Root = styled('div')(() => ({
  [`& .${classes.spreadsheet}`]: {
    '& td.table-header': {
      height: '53px',
      whiteSpace: 'normal !important',
    },
  },
}));

const DCFSummaryTable = (props: DCFSummaryTableProps) => {
  const { format, formatDispatch, spreadsheets, onChange, workbook } = props;
  const { dcfSummary: dcfSummarySpreadsheet } = getObjectValue(spreadsheets);

  const dcfSummarySheetProps = {
    ...dcfSummarySpreadsheet,
    sheet: dcfSummarySpreadsheet,
    key: getStringValue(dcfSummarySpreadsheet?.name),
    workbook,
    onChange,
    format,
    formatDispatch,
    className: classes.spreadsheet,
  } as unknown as typeof ScalarSpreadsheet;

  return (
    <Root>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore: ScalarSpreadsheet is not typed */}
      <ScalarSpreadsheet {...dcfSummarySheetProps} />
    </Root>
  );
};

export default DCFSummaryTable;
